import { render, staticRenderFns } from "./GameTypes.vue?vue&type=template&id=ed657dc6&"
import script from "./GameTypes.vue?vue&type=script&lang=js&"
export * from "./GameTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports